<template>
  <div class="create-task">
    <div class="choose-type">
      <span class="title">选择音频、视频文件语言</span><span class="important">*</span>
    </div>
    <div class="tips">必须根据音频、视频文件语言种类进行选择</div>
    <a-radio-group v-model="langType" :default-value="langType" @change="changeType">
      <a-radio
        v-for="item in Object.values(langTypeConfig)"
        :key="item.value"
        :value="item.value"
        :data-rlog="item.rlogKey"
        >{{ item.label }}</a-radio
      >
    </a-radio-group>
    <div class="choose-type">
      <span class="title">选择音频、视频文件</span><span class="important">*</span>
    </div>
    <div class="tips">目前仅支持mp3、mp4格式文件批量制作</div>
    <ChooseProductFile
      ref="chooseProductFileRef"
      rlogKey="set_chose_click"
      @update="update"
      :langType="langType"
    >
      <div class="btn">选择</div>
    </ChooseProductFile>
  </div>
</template>

<script>
import { ref } from 'vue';
import ChooseProductFile from './ChooseProductFile/index.vue';
import { langTypeConfig, defaultLangType } from '../../hearingDetail/config';

export default {
  components: {
    ChooseProductFile,
  },
  emits: ['update'],
  setup(props, context) {
    const chooseProductFileRef = ref(null);
    const langType = ref(defaultLangType);
    function changeType(newValue) {
      langType.value = newValue.target.value;
    }
    function update() {
      context.emit('update');
    }
    return {
      langTypeConfig,
      chooseProductFileRef,
      langType,
      changeType,
      update,
    };
  },
};
</script>
<style lang="scss" scoped>
::v-deep(.toggle-btn) {
  width: 160px;
  height: 40px;
  margin: 0 auto;
}
::v-deep(ant-radio:hover) {
  border: 1px solid #ff333a !important;
}
.create-task {
  line-height: 100%;
  position: relative;
  background: url('../imgs/bg.png') bottom right no-repeat;
  background-size: 260px 260px;
  min-height: 492px;
  height: calc(100% - 48px);
  ::v-deep(.ant-radio-wrapper) {
    margin: 0 25px;
  }
  ::v-deep(.ant-radio-checked .ant-radio-inner) {
    border-color: $red1;
  }
  ::v-deep(.ant-radio-inner::after) {
    background-color: $red1;
  }
  ::v-deep(.ant-radio-group) {
    margin: 0 auto;
    text-align: center;
    display: block;
  }
}
.choose-type {
  text-align: center;
  font-size: 17px;
  margin: 0 auto 12px;
  padding-top: 100px;
}
.title {
  line-height: 20px;
  color: #212327;
  font-weight: bold;
}
.important {
  color: #ff333a;
}
.tips {
  color: #898a8e;
  font-size: 12px;
  margin: 0 auto 20px;
  text-align: center;
}
.btn {
  cursor: pointer;
  background: #ff333a;
  border-radius: 8px;
  margin: 0 auto;
  color: #ffffff;
  width: 160px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 15px;
}
.btn:hover,
.btn:active {
  background: #e63037;
}
</style>
